// import React from 'react';
import React from "react";
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './RestaurantNavigation.css';
import cx from 'classnames';
import { connect } from 'react-redux';
import HeaderAfterLogin from "../HeaderAfterLogin/HeaderAfterLogin";
import HeaderBeforeLogin from "../HeaderBeforeLogin/HeaderBeforeLogin";
import SocketContext from '../../../SocketContext';
class RestaurantNavigation extends React.Component {

  render() {
    const { isRestaurant } = this.props
    return (
      <SocketContext.Consumer>
        {
          socket => (
            <div className={cx(s.navigationLink, s.navigationLinkres)}>
              {isRestaurant ? <HeaderAfterLogin socket={socket} /> : <HeaderBeforeLogin />}
            </div>
          )
        }
      </SocketContext.Consumer>

    );
  }
}
const mapStateToProps = (state) => ({
  isRestaurant: state.runtime.isRestaurantAuthenticated
});

const mapDispatchToProps = {};

export default withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(RestaurantNavigation));